import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="bg-brand-navy mt-[60px]" data-id="element-221">
      <div className="max-w-[1100px] mx-auto py-9 px-6 grid grid-cols-1 md:grid-cols-[2fr_1fr_1fr] gap-6 md:gap-10" data-id="element-222">
        <div data-id="element-223">
          <div className="flex flex-col" data-id="element-224">
            <div className="font-serif text-[1.5rem] font-bold text-white tracking-[-0.02em] leading-none" data-id="element-225">
              Vital<span className="text-brand-red" data-id="element-226">-</span>Wegweiser
            </div>
            <div className="font-sans text-[0.65rem] tracking-[0.14em] uppercase text-white/40 mt-1" data-id="element-227">
              Ihr Ratgeber für Gesundheit & Wohlbefinden
            </div>
          </div>
          <p className="font-sans text-[0.75rem] text-white/50 leading-[1.7] mt-3" data-id="element-228">
            Vital-Wegweiser informiert seit Jahren über Gesundheitsthemen,
            Naturheilkunde und ein aktives Leben. Unsere Inhalte sind
            redaktionell unabhängig und wissenschaftlich recherchiert.
          </p>
        </div>

        <div data-id="element-229">
          <h5 className="font-sans text-[0.65rem] tracking-[0.12em] uppercase text-white/40 mb-3" data-id="element-230">
            Themen
          </h5>
          <a href="#" className="block font-sans text-[0.78rem] text-white/60 no-underline mb-1.5 hover:text-white transition-colors" data-id="element-231">
            Männergesundheit
          </a>
          <a href="#" className="block font-sans text-[0.78rem] text-white/60 no-underline mb-1.5 hover:text-white transition-colors" data-id="element-232">
            Schlaf & Erholung
          </a>
          <a href="#" className="block font-sans text-[0.78rem] text-white/60 no-underline mb-1.5 hover:text-white transition-colors" data-id="element-233">
            Naturheilkunde
          </a>
          <a href="#" className="block font-sans text-[0.78rem] text-white/60 no-underline mb-1.5 hover:text-white transition-colors" data-id="element-234">
            Ernährung
          </a>
          <a href="#" className="block font-sans text-[0.78rem] text-white/60 no-underline mb-1.5 hover:text-white transition-colors" data-id="element-235">
            Fitness
          </a>
        </div>

        <div data-id="element-236">
          <h5 className="font-sans text-[0.65rem] tracking-[0.12em] uppercase text-white/40 mb-3" data-id="element-237">
            Magazin
          </h5>
          <a href="#" className="block font-sans text-[0.78rem] text-white/60 no-underline mb-1.5 hover:text-white transition-colors" data-id="element-238">
            Über uns
          </a>
          <Link to="/impressum" className="block font-sans text-[0.78rem] text-white/60 no-underline mb-1.5 hover:text-white transition-colors" data-id="element-239">
            Impressum
          </Link>
          <Link to="/datenschutz" className="block font-sans text-[0.78rem] text-white/60 no-underline mb-1.5 hover:text-white transition-colors" data-id="element-240">
            Datenschutz
          </Link>
          <Link to="/kontakt" className="block font-sans text-[0.78rem] text-white/60 no-underline mb-1.5 hover:text-white transition-colors" data-id="element-241">
            Kontakt
          </Link>
          <a href="#" className="block font-sans text-[0.78rem] text-white/60 no-underline mb-1.5 hover:text-white transition-colors" data-id="element-242">
            Werben
          </a>
        </div>
      </div>

      <div className="border-t border-white/10" data-id="element-243">
        <div className="max-w-[1100px] mx-auto py-4 px-6 flex flex-col md:flex-row justify-between items-center gap-2" data-id="element-244">
          <p className="font-sans text-[0.68rem] text-white/35 m-0" data-id="element-245">
            © 2026 Vital-Wegweiser. Alle Rechte vorbehalten.
          </p>
          <p className="font-sans text-[0.68rem] text-white/35 m-0" data-id="element-246">
            <strong className="text-white/60 font-medium" data-id="element-247">
              Anzeige / Advertorial
            </strong>{' '}
            &nbsp;·&nbsp;{' '}
            <Link to="/impressum" className="text-white/35 hover:text-white transition-colors" data-id="element-248">
              Impressum
            </Link>{' '}
            &nbsp;·&nbsp;{' '}
            <Link to="/datenschutz" className="text-white/35 hover:text-white transition-colors" data-id="element-249">
              Datenschutz
            </Link>
          </p>
        </div>
      </div>
    </footer>;
}